module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/3/4-3f6c8031b7f8ac23d2df5dd302eae782.jpg";